import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild, TemplateRef, Output, EventEmitter} from '@angular/core';
import { MapService } from 'app/services/map/map.service';
import { Subscription } from 'rxjs/Subscription';
import { Config } from "../../app.config";
import { LoginService } from '../../services/login/login.service';
declare var $;//jquery

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnChanges {
    /* Events Emitter's */
    @Output() private toolChecked = new EventEmitter<String>();
    @Output() private loginModalVisibilityToggled = new EventEmitter<boolean>();
    @Output() private closeTools = new EventEmitter<String>();
    @Input() private tipusHeader: string = "default";
    @Output() private selectedCandidate = new EventEmitter<Object>();
    @Input() private slideInOutLayer;
    @Input() private slideInOutTools;
    //private attributes
    private _leftMenuActive: boolean = false;
    private _rightMenuActive: boolean = false;
    //public attributes
    leftMenuButtonClasses: {};
    rightMenuButtonClasses: {};
    public isLoginModalActive: boolean = false;
    public isLoggedIn: boolean = false;
    public enableLogin: boolean = false;
    public userName: string = "";
    private loggedIn$: Subscription;
    private userName$: Subscription;

    constructor(
        private loginService: LoginService,
        private mapService: MapService
    ) {
        this.loggedIn$ = this.loginService.getLoggedInObservable().subscribe(
            newValue => this.isLoggedIn = newValue
        );
        this.userName$ = this.loginService.getUserObservable().subscribe(
            newValue => this.userName = newValue
        );
    }

    ngOnInit() {
        //definim l'estil per defecte dels colors
        this.setCurrentClasses();
        this.mapService.getConfiguration().then(data => {
            this.enableLogin = data["enableLogin"];
          });
    }

    ngOnChanges(changes: SimpleChanges) {
        console.debug(">>> MeasureDistanceControlComponent --> ngOnChanges");
        try {
            if (typeof (changes.slideInOutLayer) !== "undefined" && changes.slideInOutLayer.currentValue) {
                this._rightMenuActive = changes.slideInOutLayer.currentValue === "in";
                this.setCurrentClasses();
            }
            if (typeof (changes.slideInOutTools) !== "undefined" && changes.slideInOutTools.currentValue) {
                this._leftMenuActive = changes.slideInOutTools.currentValue === "in";
                this.setCurrentClasses();
            }
        }
        catch (e) { }
    }

    ngOnDestroy() {
        this.loggedIn$.unsubscribe();
        this.userName$.unsubscribe();
    }

    setCurrentClasses() {
        // CSS classes: added/removed per current state of component properties
        this.rightMenuButtonClasses = {
            layerMenuIcon: true,
            selected: this._rightMenuActive         /*rotate: this._leftMenuActive*/
        };

        this.leftMenuButtonClasses = {
            toolsMenuIcon: true,
            selected: this._leftMenuActive
        };
    }

    toggleLeftMenu() {
        if (this._rightMenuActive) {
            this._rightMenuActive = false;
        }
        this._leftMenuActive = true;
        this.setCurrentClasses();
        this.toolChecked.emit("tools");
    }

    toggleRightMenu() {
        if (this._leftMenuActive) {
            this._leftMenuActive = false;
        }
        this._rightMenuActive = true;
        this.setCurrentClasses();
        this.toolChecked.emit("layer");
    }

    public toggleLoginModal() {
        if (this.isLoggedIn) return;
        this.isLoginModalActive = !this.isLoginModalActive;
        this.loginModalVisibilityToggled.emit(this.isLoginModalActive);
    }

    public logout() {
        this.loginService.logOut();
        this.isLoginModalActive = false;
        this.loginModalVisibilityToggled.emit(this.isLoginModalActive);
    }

    selectedCandidateHandler(event) {
        this.selectedCandidate.emit(event);
    }

    private closeToolsHandler() {
        console.log(this.tipusHeader);
        this.closeTools.emit(this.tipusHeader);
        this.toggleRightMenu();
    }
    private hasActivatedResponsiveHandler(event: boolean) {
        if (event) {
            this.tipusHeader = "searchResponsive";
        } else {
            this.tipusHeader = "default";
        }
    }
}



// WEBPACK FOOTER //
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/header/header.component.ts